import alt from './../alt';
import RequestMethod from './../lib/RequestMethod';
import request from './../lib/request';
import selectn from 'selectn';
import _ from 'lodash';
import handleRequestError from './../lib/handleRequestError';
import moment from 'moment';
import AppActions from './../actions/AppActions';

function apiGetDeleteArguments() {
    const args = [...arguments];

    const params = _.find(args, arg => typeof arg === "object") || void 0;
    const [onSuccess = _.noop, onError = handleRequestError] = _.filter(args, arg => _.isFunction(arg));

    return {
        params,
        onSuccess,
        onError
    };
}

function apiPostPutArguments() {
    const args = [...arguments];

    let [params, data] = _.filter(args, arg => !_.isFunction(arg) && !_.isArray(arg));

    if (!data) {
        data = params;
        params = {};
    }

    const [onSuccess = _.noop, onError = handleRequestError] = _.filter(args, arg => _.isFunction(arg));
    const files = _.find(args, arg => _.isArray(arg)) || [];

    return {
        params,
        data,
        onSuccess,
        onError,
        files
    };
}

function getHeaders(accessToken) {
    const headers = {};

    if (accessToken) {
        headers.authorization = `Bearer ${accessToken}`;
    }

    const apiKey = window.localStorage.getItem('apiKey');

    if (apiKey) {
        headers['Api-Key'] = apiKey;
    }

    return headers;
}

function minutesRemaining(secondsSinceUnixEpoch) {
    const utc = moment.utc();
    const expiry = moment.unix(+(secondsSinceUnixEpoch));
    return expiry.diff(utc, 'minutes');
}

function tokenHasExpired(expires) {
    if (expires) {
        let minutes = minutesRemaining(expires);

        console.log('Expires in ' + minutes + ' minutes.');

        if (minutes <= 5) {
            return true;
        }
    }

    return false;
}

function getAccessToken(alt, updateState) {
    return new Promise(function (resolve, reject) {
        const state = alt.stores.AppStore.state;
        const accessToken = selectn('authData.accessToken', state);

        if (accessToken) {
            let expires = selectn('authData.expires', state);

            if (tokenHasExpired(expires)) {
                resolve(null);
            } else {
                resolve(accessToken);
            }
        } else {
            resolve(null);
        }
    });
}

export function get(url, params, onSuccess, onError) {
    const args = apiGetDeleteArguments(params, onSuccess, onError);

    getAccessToken(alt, AppActions.updateState).then(accessToken => {
        request({
            method: RequestMethod.Get,
            url,
            params: args.params,
            headers: getHeaders(accessToken)
        })
            .then(args.onSuccess)
            .catch(args.onError);
    });
}

export function getAll(requestPromises) {
    const updateState = AppActions.updateState;

    return new Promise(function (resolve, reject) {
        getAccessToken(alt, updateState)
            .then(accessToken => {
                Promise.all(requestPromises)
                    .then(resolve)
                    .catch(reject);
            })
            .catch(reject);
    });
}

export function post(url, params, data, onSuccess, onError) {
    const args = apiPostPutArguments(params, data, onSuccess, onError);

    getAccessToken(alt, AppActions.updateState).then(accessToken => {
        request({
            method: RequestMethod.Post,
            url,
            params: args.params,
            data: args.data,
            headers: getHeaders(accessToken),
            files: args.files
        })
            .then(args.onSuccess)
            .catch(args.onError);
    });
}

export function put(url, params, data, onSuccess, onError) {
    const args = apiPostPutArguments(params, data, onSuccess, onError);

    getAccessToken(alt, AppActions.updateState).then(accessToken => {
        request({
            method: RequestMethod.Put,
            url,
            params: args.params,
            data: args.data,
            headers: getHeaders(accessToken),
            files: args.files
        })
            .then(args.onSuccess)
            .catch(args.onError);
    });
}

export function del(url, params, onSuccess, onError) {
    const args = apiGetDeleteArguments(params, onSuccess, onError);

    getAccessToken(alt, AppActions.updateState).then(accessToken => {
        request({
            method: RequestMethod.Delete,
            url,
            params: args.params,
            headers: getHeaders(accessToken)
        })
            .then(args.onSuccess)
            .catch(args.onError);
    });
}